import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Shirt Design: ALS Walk </h1>

    
    <div className="imgs max600">
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/mockup.png')} data-skip-gallery/>
        </div>
    </div>

    <p>During my time as Graphic Artist Intern at <a href="https://www.tobiidynavox.com/en-US/?MarketPopupClicked=true" target="_blank">Tobii Dynavox</a>, 
    I created the above shirt design for the company's participation in the local 
    "Walk to Defeat ALS" event that occurred in 2017.</p>

    <p>Previous year's shirt designs:</p>

    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/ref1.jpg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/ref2.jpg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/ref3.jpg')} data-skip-gallery/>
        </div>
    </div>

    <p>First, I wanted to create some visual identity or icon for the shirt. I landed on 
    the ALS ribbon, which is a blue and white ribbon. I designed an icon that combined 
    both the white and blue ribbon with a walking person symbol:</p>

    <div className="imgs max200">
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/ribbon.png')} data-skip-gallery/>
            <p>Variations on shape of my walking man/ALS ribbon symbol</p>
        </div>
    </div>

    <p>Since Tobii's brand colors involve blue and green, I wanted to incorporate 
    these into my shirt design. See a few of my different ideas below:</p>

    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/v3.png')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/v2.png')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/v1.png')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/v4.png')} data-skip-gallery/>
        </div>
    </div>

    <p>Ultimately, I decided on the below design for the shirt, which included the white 
    and blue ALS ribbon/walking man icon, Tobii Dynavox's green branding, and Tobii 
    Dynavox's branding font. The company had this design printed on a bulk order of 
    shirts, and we all wore it at the 2017 ALS walk to represent "Team Tobii Dynavox".</p>

    <div className="imgs max600">
        <div>
            <img src={require('../assets/graphicDesign/tobiiShirt/finalDesign.png')} data-skip-gallery/>
        </div>
    </div>
    
    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.